import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import OurTeam from "./Pages/OurTeam";
import MembershipCategories from "./Pages/MembershipCategories";
import BusinessLeagueModel from "./Pages/BusinessLeagueModel";
import Footer from "./Components/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>

     <ScrollToTop />

     <Navbar />

      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/OurTeam" element={<OurTeam />} />
        <Route path="/MembershipCategories" element={<MembershipCategories />} />
        <Route path="/BusinessLeagueModel" element={<BusinessLeagueModel />} />

      </Routes>

       <Footer /> 

    </BrowserRouter>
  );
}

export default App;